module.exports = __webpack_public_path__ + "img/phone-32.c0afec25.svg";